import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("mql_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch((err) => { if (err?.response?.status === 401) localStorage.removeItem("mql_token"); })
      .finally(() => setLoading(false));
  }, []);

  const refresh = async () => {
    const me = await api.get("/auth/me");
    setUser(me.data);
    return me.data;
  };

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    if (r.data.two_factor_required) return { challenge: r.data.challenge_token };
    localStorage.setItem("mql_token", r.data.token);
    return refresh();
  };

  const verify2fa = async (challenge_token, code, recovery_code) => {
    const r = await api.post("/auth/login/2fa", { challenge_token, code: code || null, recovery_code: recovery_code || null });
    localStorage.setItem("mql_token", r.data.token);
    return refresh();
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("mql_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const registerSupplier = async (form, kyc) => {
    const fd = new FormData();
    ["name", "email", "password"].forEach((k) => fd.append(k, form[k]));
    ["telegram", "whatsapp", "ktp", "selfie"].forEach((k) => fd.append(k, kyc[k]));
    fd.append("accept_policy", form.accept_policy ? "true" : "false");
    const r = await api.post("/auth/register-supplier", fd);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("mql_token");
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, login, verify2fa, refresh, register, registerSupplier, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
